import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useAppStatus } from 'src/context/AppStatusContext';
import { useUtcCountdown, computeUtcDiffMinutes } from 'src/hooks/useUtcCountdown';

const MaintenanceBanner = () => {
    const { maintenanceMode, refetch } = useAppStatus();
    const [dismissed, setDismissed] = useState(false);
    const startsInMinutes = useUtcCountdown(maintenanceMode?.scheduledStartTimeUtc);

    // Reset dismiss when the maintenance schedule changes
    useEffect(() => {
        setDismissed(false);
    }, [maintenanceMode?.scheduledStartTimeUtc]);

    // Trigger refetch when countdown reaches 0 so the guard switches to MaintenancePage
    useEffect(() => {
        if (startsInMinutes === 0) {
            refetch();
        }
    }, [startsInMinutes, refetch]);

    if (dismissed) return null;
    if (!maintenanceMode?.isMaintenanceScheduled) return null;

    const estimatedDowntime = computeUtcDiffMinutes(maintenanceMode.scheduledStartTimeUtc, maintenanceMode.estimatedEndTimeUtc);
    const downtimeSuffix =
        estimatedDowntime != null ? ` Expected downtime: approximately ${estimatedDowntime} minute${estimatedDowntime !== 1 ? 's' : ''}.` : '';

    const liveMinutes = startsInMinutes ?? 0;
    const message =
        liveMinutes > 0
            ? `Scheduled maintenance starting in ${liveMinutes} minute${liveMinutes !== 1 ? 's' : ''}.${downtimeSuffix} Please save your work.`
            : `Maintenance is about to begin. Please save your work now.`;

    return (
        <BannerWrapper>
            <BannerText>{message}</BannerText>
            <DismissButton onClick={() => setDismissed(true)}>✕</DismissButton>
        </BannerWrapper>
    );
};

export default MaintenanceBanner;

const BannerWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff3cd;
    border-bottom: 1px solid #ffc107;
    padding: 8px 16px;
    position: relative;
`;

const BannerText = styled.span`
    font-size: 14px;
    color: #856404;
    font-weight: 500;
`;

const DismissButton = styled.button`
    position: absolute;
    right: 16px;
    background: none;
    border: none;
    font-size: 16px;
    color: #856404;
    cursor: pointer;
    padding: 4px 8px;

    &:hover {
        color: #533f03;
    }
`;
